import { createContext, useContext } from 'react';
const ObserverContext = /*#__PURE__*/createContext(null);
export const ProvideObserver = ObserverContext.Provider;
export const useObserverContext = () => {
  return useContext(ObserverContext);
};